import { Output, EventEmitter, ChangeDetectionStrategy, Input, Component, OnInit } from '@angular/core';
import { MfsUser } from '@feature/_app_modules/mojo-for-suppliers/user-admin/models/mfs-user';
import { SelectItem } from 'primeng/api';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MfsPreviewDialogResult } from '@feature/preview-mode/mfs-preview-mode/models/mfs-preview-dialog-result';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojo-mfs-preview-mode-dialog',
  templateUrl: './mfs-preview-mode-dialog.component.html'
})
export class MfsPreviewModeDialogComponent implements OnInit {

  @Input()
  title: string = 'Preview';

  @Input()
  users: SelectItem[];

  @Input()
  suppliers: SelectItem[];

  @Input()
  creditors: SelectItem[];

  @Input()
  showDialog: boolean;

  @Output()
  onOk = new EventEmitter<MfsPreviewDialogResult>();

  @Output()
  onCancel = new EventEmitter();

  previewByOptions: SelectItem[];

  form: UntypedFormGroup;

  constructor(
    formBuilder: UntypedFormBuilder ) {
    this.form = this.createForm(formBuilder);
    this.previewByOptions = this.getPreviewByOptions();
  }

  ngOnInit() {
  }

  cancelHandler() {
    this.showDialog = false;
    this.onCancel.emit();
  }

  okHandler() {
    const result = this.mapToResult();
    this.showDialog = false;
    this.onOk.emit(result);
  }

  private mapToResult() {
    const result = new MfsPreviewDialogResult();
    result.previewBy = this.form.get('previewBy').value;
    result.supplier = this.form.get('selectedSupplier').value;
    result.user = this.form.get('selectedUser').value;
    result.creditor = this.form.get('selectedCreditor').value;
    return result;
  }

  get previewByValue() {
    return this.previewBy.value;
  }

  get previewBy() {
    return this.form.get('previewBy');
  }

  private formValidator(): ValidatorFn {
    return (control: UntypedFormGroup): ValidationErrors | null => {

      const errors: ValidationErrors = {};
      const pBy = control.get('previewBy').value;
      if (pBy === 'supplier' && !control.get('selectedSupplier').value) {
          errors.supplierRequired = { message: 'Supplier required' };
      }

      if (pBy === 'creditor' && !control.get('selectedCreditor').value) {
        errors.creditorRequired = { message: 'Creditor required' };
      }

      if (pBy === 'user' && !control.get('selectedUser').value) {
        errors.userRequired = { message: 'User required' };
      }

      return Object.keys(errors).length ? errors : null;

    };

  }

  private createForm(formBuilder: UntypedFormBuilder) {
    const form = formBuilder.group({
      previewBy: [null, [Validators.required]],
      selectedSupplier: [null],
      selectedCreditor: [null],
      selectedUser: [null],
    },
    {
      validator: this.formValidator()
    }
    );
    return form;
  }

  private getPreviewByOptions() {
    const l = [
      { label: 'Supplier', value: 'supplier' },
      { label: '\'Other\' Creditor', value: 'creditor' },
      { label: 'User', value: 'user' },
    ];
    return l;
  }

}
